export interface Voucher {
  id?: string;
  voucherNumber: string;
  merchantId: string;
  merchantName?: string;
  merchantOrderReference: string;
  productDescription: string;
  amount: number;
  currency: string;
  voucherStatus: VoucherStatus;
  voucherStatusDescription?: string;
  expiresAt: string;
  paidAt?: string;
  settledWithRetailerAt?: string;
  settledWithMerchantAt?: string;
  retailerId?: string;
  retailerPaymentRef?: string;
  retailerCommissionAmount?: number;
  merchantCommissionAmount?: number;
  dateCreated?: string;
  lastUpdated?: string;
  status?: string;
  version?: string;
}

export enum VoucherStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  CUSTOMER_PAID = 'CUSTOMER_PAID',
  AWAITING_RETAILER_SETTLEMENT = 'AWAITING_RETAILER_SETTLEMENT',
  AWAITING_MERCHANT_SETTLEMENT = 'AWAITING_MERCHANT_SETTLEMENT',
  SETTLED = 'SETTLED',
  EXPIRED = 'EXPIRED',
  REFUNDED = 'REFUNDED',
  CANCELLED = 'CANCELLED',
}

export interface VoucherCreateRequest {
  merchantId: string;
  merchantOrderReference: string;
  productDescription: string;
  amount: number;
  currency: string;
}

export interface VoucherPaymentRequest {
  retailerId: string;
  storeId: string;
  retailerPaymentRef: string;
  totalAmount: number;
  retailerCommissionAmount?: number;
  currency: string;
}

export interface StatusHistoryResponse {
  id: number;
  entityType: string;
  entityId: number;
  entityReference: string;
  entityName?: string;
  fromStatus?: string;
  fromStatusDisplay?: string;
  toStatus: string;
  toStatusDisplay: string;
  transitionDate: string;
  changedBy?: string;
  changedById?: number;
  changeReason?: string;
  comments?: string;
  isAutomatic: boolean;
  triggerEvent?: string;
  ipAddress?: string;
  userAgent?: string;
  transitionDescription?: string;
  isReversion: boolean;
  durationInPreviousStatus?: string;
  timeSinceTransition?: string;
  dateCreated: string;
}